export const highlightText = (text: any, keyword: string) => {
  if (!keyword) {
    return text
  }
  try {
    const regex = new RegExp(keyword, 'gi')
    const newText = text.replace(regex, `<mark class="h-highlight">$&</mark>`)
    return newText
  } catch {
    return text
  }
}
